require('./notesLayout.less');

var Marionette = require('marionette'),
    _ = require('underscore'),
    $ = require('jquery'),
    NotesHeaderView = require('./header/header'),
    NotesCollectionView = require('./noteCollectionView');



// TODO: extend from 'subPanel content view.... see 'indexes' ... still ... ?


module.exports = Marionette.LayoutView.extend({

    template: require('./subSidePane.hbs'),

    onRender: Backbone.View.prototype.unwrap,

    regions: {
        header:                         '.sp-header',
        noteViews:                      '.sp-body'
    },

    initialize: function(options) {

        _.extend (this, _.pick(options, 'el', 'notesCollection', 'channel') );

        _.bindAll(this, 'updateOnPgChange', 'updateOnViewModeChange');

    },


    serializeData: function() {
        return {
            paneId: 'FV-notes'
        };
    },
    /*
    * ( Must be in DOM )
    * */
    onShow: function() {

        this.header.show( new NotesHeaderView({
            collection: this.notesCollection,
            channel: this.channel
        }));

        this.noteViews.show( new NotesCollectionView({
            collection: this.notesCollection,
            channel: this.channel
        }));


    },


    expandedNoteChange: function(note, priorNote) {

        if (note) {
            this.$el.addClass('note-expanded');
            this.header.currentView.enterMode(note, 'note-expanded');
            note.uiModel.toggle('expanded');
        } else {
            this.$el.removeClass('note-expanded');
            this.header.currentView.exitModeAllModes();
            priorNote.uiModel.toggle('expanded');
        }

    },
    updateOnPgChange: function( options ) {

        // Update pg number OF active note view if editingNote and noteType is pageTextNote and is new --
        // or if not new text note, disable navigation.
        this.noteViews.currentView.setNoteViewsNavigability( options.activeNote, options.page );

        this.channel.trigger('notes:updateNoteTypesToDisable'); // ( now not passing options may to pass options.page )

    },

    updateOnViewModeChange: function(viewMode, options) {

        var noteViews = this.noteViews.currentView;

        this.channel.trigger('notes:updateNoteTypesToDisable');

        viewMode === 'pdf'
            ? noteViews.enterPDFMode()
            : noteViews.exitPDFMode(options);

    },
    toggleEditMode: function(on) {
        this.$el.toggleClass('noteEditing', on); //the entire view -- way tooo linked
    },
    updatePostActiveNoteChange: function(actionOptions) {

        var note = actionOptions.note,
            noteList = this.noteViews.currentView,
            header = this.header.currentView;

        var isEntering = actionOptions.note !== null;
        //actions for this layout first
        if (isEntering) {
            this.toggleEditMode(1);
            var createOrEditMode = actionOptions.isNew
                ? 'create'
                : !actionOptions.isReadingFlashNote
                    ? 'edit'
                    : 'reading'; /* for now only for flash notes that are unopened */
            header.enterMode(note, createOrEditMode);
        } else {
            this.toggleEditMode(0);
            header.exitModeAllModes();
        }

        // then main action for note list
        noteList.updateActiveNoteViewPostNoteChange(actionOptions, isEntering);
    },

    destroy: function() {

        Marionette.LayoutView.prototype.destroy.apply(this, arguments);
        this.$el = null;
        this.el = null;
    }
});






/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/views/notesLayout.js
 ** module id = 485
 ** module chunks = 0
 **/